import { useState } from "react";
import { ReactComponent as PersonIcon } from "../../../../../assets/Icons/Pages/Operational/Academic/Attendance/Person.svg";
import { ReactComponent as PersonInMobileIcon } from "../../../../../assets/Icons/Pages/Operational/Academic/Attendance/PersonInMobile.svg";
import FilterBtn from "../../../../Universal/FilterBtn.component";
import TogglePushBtn from "../../../../Universal/TogglePushBtn.component";
const PageHeaderCustom = ({ setGenderWaysFilter, genderWaysFilter }) => {
  const [filteredData, setFilteredData] = useState([]);
  return (
    <div
      className="flex-row align-center justify-start g-05"
      style={{ height: "2.5rem" }}
    >
      <div
        className="flex-row align-center justify-start g-05"
        style={{ flexWrap: "wrap" }}
      >
        <TogglePushBtn
          type="radio"
          setVal={(val) => setGenderWaysFilter(val)}
          name="examreportToggle"
          value={genderWaysFilter}
          icon={
            <PersonIcon
              fill="white"
              style={{ width: "1.3rem", height: "1.3rem" }}
            />
          }
          icontype="svg"
          label="All"
        />
        <TogglePushBtn
          type="radio"
          setVal={(val) => setGenderWaysFilter(val)}
          name="examreportToggle"
          value={genderWaysFilter}
          icon={
            <PersonInMobileIcon
              fill="white"
              style={{ width: "1.3rem", height: "1.3rem" }}
            />
          }
          icontype="svg"
          label="Boys"
        />
        <TogglePushBtn
          type="radio"
          setVal={(val) => setGenderWaysFilter(val)}
          name="examreportToggle"
          value={genderWaysFilter}
          icon={
            <PersonInMobileIcon
              fill="white"
              style={{ width: "1.3rem", height: "1.3rem" }}
            />
          }
          icontype="svg"
          label="Girls"
        />
      </div>

      <FilterBtn
        setFilteredData={setFilteredData}
        filteredData={filteredData}
        filterArray={[
          "I",
          "II",
          "III",
          "IV",
          "V",
          "VI",
          "VII",
          "VIII",
          "IX",
          "X",
        ]}
        btnTitle="By Classes"
      />
      <FilterBtn
        setFilteredData={setFilteredData}
        filteredData={filteredData}
        filterArray={["Teacher", "Students"]}
        btnTitle="By Designation"
      />

      <button className="absenteesBtn">
        Absentees
        <input type="checkbox" />
      </button>
    </div>
  );
};

export default PageHeaderCustom;
